"use client";
import Image from "next/image";
import { useDispatch } from "react-redux";
import { setMenuTitles ,setPrevPath} from "@/store";
import { useEffect, useRef } from "react";
import { setHamburgerState } from "@/store";
import { getFromLocale, typeCheck } from "@/utils";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

export const DropdownMenu = ({ name, data }) => {
  const t = useTranslations();
  const dispatch = useDispatch();
  const listRef = useRef();
  const router = useRouter();
  const access_token = getFromLocale();
  const lang = getFromLocale("language");
  
  let type = 0;

  const isBrowser = () => typeof window !== "undefined";
  if (isBrowser()) {

    const windowObject = window.location.hostname.replace(/^www\./, "");

    if (windowObject == "sayt.az" || windowObject == "localhost" ) {
      type = 0;
    } else if (windowObject == "websiteca.com") {
      type = 1;
    }

    if (lang === 'az') {
      type = 0;
    } else if (lang === 'en') {
      type = 1;
    }
  }

  const orderTracking = {
    id: "orderTracking",
    title: t("orderTrackingAll"),
    icon: "order-track",
    description: t("orderTrackDecs"),
    to: "/#order-tracking",
  };
  const costCalculator = {
    id: "costCalculator",
    title: t("costCalculator"),
    icon: "calculator",
    description: t("costCalcDesc"),
    to: "/cost-calculator",
  };

  const websitePage = {
    id: "websitePage",
    title: t("websiteMenuTitle"),
    icon: "website-program",
    description: t("websiteMenuSubtitle"),
    to: typeCheck(type, [ "/sayt-hazirlanmasi", "/website-development" ]),
  };


  function createDynamicMenuItems(data, targetSlugs) {
    const validSlugs = Array.isArray(targetSlugs) ? targetSlugs : [targetSlugs];

    return validSlugs.reduce((menuItems, targetSlug) => {
      const targetData = data?.body?.find((item) => item?.slug === targetSlug);
      if (targetData) {
        const items = targetData?.children?.map((item) => ({
          id: item.id,
          title: item.title,
          icon: `https://api.websiteca.com/storage/${item.icon}`,
          description: item.description, 
          to: typeCheck(type, [
            `/${item.slug}`,
            `/${item.slug}`,
          ]),
        }));
        return [...menuItems, ...items];
      }
      return menuItems;
    }, []);
  }

  const dynamicWebsiteItems = [
    websitePage,
    ...createDynamicMenuItems(data, ["website", "veb-sayt"]),
  ];

  const dynamicServicesItems = [
    orderTracking,
    costCalculator,
    ...createDynamicMenuItems(data, ["services", "xidmetler"]),
  ];
  
  const menus = {

    website: dynamicWebsiteItems,

    domain: [
      {
        id: "normal-domain",
        icon: "network-browser",
        title: t("domain"),
        description: t("startingFrom4"),
        to: typeCheck(type, ["/domain", "/domain"]),
      },
      {
        id: "free_domain_registration",
        icon: "network-www",
        title: t("freeDomain"),
        description: t("freeDomain_desc"),
        to: typeCheck(type, ["/pulsuz-domain-qeydiyyati", "/free-domain-registration"]),
      },
    ],
    
    hosting: [
      {
        id: "web_hosting",
        icon: "hosting-icon",
        title: t("web_hosting"),
        description: t("startingFrom"),
        to: typeCheck(type, ["/hosting", "/web-hosting"]),
      },
      {
        id: "virtual_private_server",
        icon: "vps-icon",
        title: t("vps"),
        description: t("startingFrom2"),
        to: typeCheck(type, ["/vps-hosting", "/vps-hosting"]),
      },
      {
        id: "dedicated_server",
        icon: "server-icon",
        title: t("server"),
        description: t("startingFrom3"),
        to: typeCheck(type, ["/dedicated-server", "/dedicated-server"]),
      },
    ],

    company: [
      {
        id: "about_us",
        icon: "about-icon",
        title: t("aboutUs"),
        description: t("aboutTitle"),
        to: typeCheck(type, ["/haqqimizda", "/aboutus"]),
      },
      {
        id: "blog",
        icon: "blog-icon",
        title: t("blog"),
        description: t("blogTitle"),
        to: typeCheck(type, [`/bloq`, `/blog`]),
      },
      {
        id: "startup",
        icon: "cpu",
        title: t("startUp_all"),
        description: t("startUp_pst"),
        to: "/startups",
      },
      {
        id: "portfolio",
        icon: "portfolio-icon",
        title: t("portfolio"),
        description: t("portofolioTitle"),
        to: typeCheck(type, ["/portfolio", "/portfolio"]),
      },
      {
        id: "career",
        icon: "career-icon",
        title: t("career"),
        description: t("carrerTitle"),
        to: "/careers",
      },
      {
        id: "freelance",
        icon: "note-icon",
        title: t("freelance"),
        description: t("freelanceTitle"),
        to: "/sign-in",
      },
      {
        id: "contact_us",
        icon: "contact-icon",
        title: t("contactUs"),
        description: t("contactTitle"),
        to: typeCheck(type, ["/elaqe", "/contact"]),
      },
    ],

    services: dynamicServicesItems,
  };

  useEffect(() => {
    const clickHandle = (e) => {
      if (!e.composedPath().includes(listRef.current)) {
        dispatch(setMenuTitles(""));
      }
    };
    document.addEventListener("click", clickHandle);
    return () => {
      document.removeEventListener("click", clickHandle);
    };
  }, [dispatch]);
  return (
    <>
      <ul
        ref={listRef}
        className="mobileMenuDropdown term-scrollbar-dropdown  flex absolute top-[2.5rem] z-[99]  lg:ml-8 md:-ml-8 -ml-3 bg-white flex-col md:py-4 py-2 text-black border border-slate-200 rounded-lg box-border md:min-w-[340px] lg:max-w-none md:max-w-[380px] max-w-[340px]"
      >
        {menus[name]?.map(({ icon, title, description, to, id }) => (
          <div
            onClick={() => {
              if (id == "freelance") {
                if (access_token) {
                  dispatch(setHamburgerState(false));
                  return router.push(
                    `${process.env.FREELANCE_URL
                    }/user/balance?access_token=${access_token}&lang=${getFromLocale(
                      "language"
                    )}`
                  );
                }      
                dispatch(setPrevPath('freelance'))

                
                // setToLocale({ value: "freelance", key: "prevPathLink" });
                dispatch(setHamburgerState(false));
                router.push(to);
              } else {
                router.push(to);
                dispatch(setHamburgerState(false));

              }
            }}
            key={title}
            className="flex items-center px-2 sm:px-8 md:pl-8 py-3 md:pr-12 lg:pr-4 cursor-pointer hover:bg-slate-50"
          >
            {icon ? (
              <div className="hidden md:block p-3 bg-blue-100 rounded-lg mr-4">
                <Image
                  priority
                  src={icon.startsWith('https://api.websiteca.com') ? icon : `/icons/${icon}.svg`}
                  alt="navbar-icon"
                  className="max-w-[28px]"
                  width={28}
                  height={28}
                />
              </div>
            ) : (
              ""
            )}

            <div className="flex flex-col">
              <p className="text-slate-700 font-medium text-base lg:w-max">
                {title}
              </p>
              <p className="text-slate-500 md:text-sm text-xs lg:w-max md:max-w-[400px] max-w-[320px] md:line-clamp-2">{description}</p>
            </div>
          </div>
        ))}
      </ul>
    </>
  );
};
